import React from 'react';
import { Modal, Field } from '../../components/ui';
import FunctionServices from './FunctionServices';

// Phone add/edit Function: full-screen, one field per row, with the catering /
// services panel below the fields once the function exists.
export default function FunctionFormMobile({ vm, event }) {
  const { editing, values, fields, saving, setField, save, closeForm } = vm;
  if (!vm.open) return null;
  return (
    <Modal
      fullScreen
      title={`${editing ? 'Edit' : 'Add'} Function`}
      onClose={closeForm}
      footer={<>
        <button className="btn light" onClick={closeForm}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
      </>}
    >
      <div className="form-grid">
        {fields.map(f => (
          <div key={f.key} style={{ gridColumn: '1 / -1' }}>
            <Field
              label={f.label} type={f.type || 'text'} value={values[f.key]}
              options={f.options} required={f.required} rows={f.rows}
              onChange={(v) => setField(f, v)}
            />
          </div>
        ))}
      </div>

      {editing
        ? <FunctionServices event={event} fn={{ ...editing, ...values }} />
        : <div className="fn-services muted" style={{ fontSize: 12.5 }}>
            Save the function first — catering and the other services are added to it afterwards.
          </div>}
    </Modal>
  );
}
